import { FormattedText } from '~/components/FormattedText'
import { BackendTransaction, OrgAssetTransfer } from '~/types'
import { cn } from '~/utils/tailwind-utils'

type TransactionMemoProps = {
  className?: string
} & (
  | { transaction: BackendTransaction | OrgAssetTransfer; memo?: never }
  | { memo: string; transaction?: never }
)

export const TransactionMemo = ({
  transaction,
  memo,
  className,
}: TransactionMemoProps) => {
  const memoText = memo ?? transaction?.memo
  if (!memoText) return null

  return (
    <div className={cn('max-w-full text-primary', className)}>
      <FormattedText text={memoText} />
    </div>
  )
}
